<a mat-list-item (click)="toggle()" style="width: fit-content;">
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
            class="submenu">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
                <mat-icon>table_chart</mat-icon>
                <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>

    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

            <!-- PERSPECTIVA-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().PERSPECTIVA)" icone="pages" titulo="Perspectiva" rota="perspectiva" toolTip="Perspectiva"></sub-menu>
            </div>

            <!-- EIXO ATIVIDADE-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().EIXO_ATIVIDADE)" icone="pages" titulo="Eixo de Atividades" rota="eixoatividade" toolTip="Eixo de Atividades"></sub-menu>
            </div>
        
        </div>
    </mat-nav-list>
